import React from 'react'
import Badge from 'react-bootstrap/Badge'
import AppBadge from './app-badge'

const DollarAmountBadge = ({ rule }) => {
  const { lower_amount, upper_amount } = rule
  const DEFAULT_MIN = '0.0'
  const DEFAULT_MAX = '999999999.99'

  let displayText

  if (lower_amount === DEFAULT_MIN && upper_amount === DEFAULT_MAX) {
    displayText = 'All $'
  } else if (lower_amount !== DEFAULT_MIN && upper_amount === DEFAULT_MAX) {
    displayText = `> $${Number(lower_amount).toLocaleString()}`
  } else if (lower_amount === DEFAULT_MIN && upper_amount !== DEFAULT_MAX) {
    displayText = `< $${Number(upper_amount).toLocaleString()}`
  } else {
    displayText = `$${Number(lower_amount).toLocaleString()} - $${Number(
      upper_amount
    ).toLocaleString()}`
  }

  return (
    <AppBadge className="text-center ms-2 bg-light text-primary fw-normal">
      {` ${displayText}`}
    </AppBadge>
  )
}

export default DollarAmountBadge
